import { useCallback, useEffect, useState } from "react";

// A counter bumped when something worth acknowledging lands, which clears
// itself after `durationMs`. The value doubles as a React key, so a repeat
// inside the window restarts the reveal rather than being swallowed by it.
export const useFlashOnce = (durationMs: number) => {
  const [flashId, setFlashId] = useState(0);

  useEffect(() => {
    if (!flashId) return;
    const timeout = setTimeout(() => setFlashId(0), durationMs);
    return () => clearTimeout(timeout);
  }, [flashId, durationMs]);

  const flash = useCallback(() => setFlashId((id) => id + 1), []);

  return { flashId, flash };
};
